import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';
import { InputType } from './';
import EmailSplit from 'assets/img/common/ic_email_ separator.svg';

interface Props {
    isValid?: boolean;
    width?: number;
    inputType?: InputType;
}

export const Input = styled.input<Props>`
    /* Remove First */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    width: ${props => props.width ? css`${props.width}px` : css`100%`};
    height: 56px;
    padding: 0 20px;
    outline: 0;
    user-select: text;
    ${theme('fontStyle.body2')}
    color: ${palette('gray_opacity_800')};
    caret-color: ${palette('gray_opacity_800')};
    background: ${palette('gray_opacity_50')};
    
    border-radius: 8px;
    box-sizing: border-box;

    ${(props) => (props.isValid
        ? css`border: 1px solid ${palette('gray_neautral_300')};`
        : css`border: 1px solid ${palette('red_900')};`
    )
    };

    &:focus {
        border: 1px solid ${palette('blue_900')};
    }

    &::placeholder {
        color: ${palette('gray_opacity_400')};
        ${theme('fontStyle.body2')}
    }
    
    &::-ms-clear{
        display: none;
    }

    ${props => props.inputType === 'EMAIL' ? css`background: url('${EmailSplit}') no-repeat 95% 50%;` : null}

    /* IE10 이상을 위한 css */
    input[type='text']::placeholder {
        color: ${palette('gray_opacity_400')};
        ${theme('fontStyle.body2')}
        opacity: 1;
    }
    input[type='text']::-webkit-input-placeholder {
        color: ${palette('gray_opacity_400')};
        ${theme('fontStyle.body2')}
    }
    /* IE */
    input[type='text']:-ms-input-placeholder {
        color: ${palette('gray_opacity_400')};
        ${theme('fontStyle.body2')}
    }
    /* Firefox */
    input[type='text']:-mos-input-placeholder {
        color: ${palette('gray_opacity_400')};
        ${theme('fontStyle.body2')}
    }

`;
